// US2043931: Pure decision predicates extracted from ProblemForm.js so the
// resolve/reopen peak-confirmation gate logic can be unit-tested against the
// REAL code the component runs (PR review finding #1). These functions are
// PURE — no React state, no I/O, no side effects. ProblemForm.js owns all
// orchestration (setIncidentEnd/setOutage/setProblem/setStatus, the
// refreshComputedPeak async sequencing, and autosave); these helpers only
// answer yes/no questions about a proposed status transition.

// RESOLVE_STATUS is the resolved status value. It mirrors the backend
// types.OutageStatusResolve / types.ResolvedStatus === "Resolve" and the
// "Resolve" statusOptions entry. Defined here as the single source of truth so
// both ProblemForm.js and these predicates share one literal.
export const RESOLVE_STATUS = "Resolve";

// isReopen reports whether a status change is a reopen: the previous status was
// "Resolve" and the new value is anything else. On a reopen the peak-
// confirmation gate must be re-armed so a subsequent re-resolve re-prompts.
export function isReopen(prevStatus, newValue) {
  return prevStatus === RESOLVE_STATUS && newValue !== RESOLVE_STATUS;
}

// shouldOpenResolveModal reports whether a status change is a NEW resolve that
// must be gated behind the MIM peak-priority confirmation modal: the new value
// is "Resolve" and the previous status was not already "Resolve".
//
// US2092239: this predicate deliberately does NOT consult incidentEnd. Impact
// End is no longer a resolve trigger — it is a plain field write — so an
// IncidentEnd that is non-zero while the status is not "Resolve" is a legal,
// first-class state. Keying the gate on incidentEnd is what let a stale or
// resurrected Impact End permanently suppress the modal and produce an
// unresolvable incident (INC4856794). Resolved-ness is keyed on status alone,
// matching both durable boundaries (S3 object placement and the resolved
// ticket index).
export function shouldOpenResolveModal(newValue, prevStatus) {
  return newValue === RESOLVE_STATUS && prevStatus !== RESOLVE_STATUS;
}
